import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { ObjectDatasetDataDto, ObjectDatasetDto, ObjectDatasetReq } from "./model/object-dataset/types";

class ObjectDatasetApiDefinition extends ApiDefinition {
  constructor() {
    super("/object-dataset");
  }

  async getObjectDatasets(companyRef: string): Promise<APIResponse<ObjectDatasetDto[]>> {
    return this.get(companyRef);
  }

  async getObjectDataset(identifier: string, companyRef: string): Promise<APIResponse<ObjectDatasetDto>> {
    return this.get(`${companyRef}/${identifier}`);
  }

  async createObjectDataset(
    objectDataset: ObjectDatasetReq,
    companyRef: string
  ): Promise<APIResponse<ObjectDatasetDto>> {
    return this.post(companyRef, objectDataset);
  }

  async deleteObjectDataset(identifier: string, companyRef: string): Promise<APIResponse<ObjectDatasetDto>> {
    return this.delete(`${companyRef}/${identifier}`);
  }

  async getObjectDatasetDataInRange(
    identifier: string,
    companyRef: string,
    startDate: string,
    endDate: string
  ): Promise<APIResponse<ObjectDatasetDataDto[]>> {
    return this.get(`${companyRef}/${identifier}/data-by-range`, {
      params: { startDate, endDate },
    });
  }

  async deleteObjectDatasetData(
    identifier: string,
    timestamp: string,
    companyRef: string
  ): Promise<APIResponse<ObjectDatasetDataDto>> {
    return this.delete(`${companyRef}/${identifier}/${timestamp}`);
  }

  async deleteObjectDatasetDataFile(
    identifier: string,
    timestamp: string,
    companyRef: string,
    filePath: string
  ): Promise<APIResponse<ObjectDatasetDataDto>> {
    return this.delete(`${companyRef}/${identifier}/${timestamp}/${filePath}`);
  }
}

const ObjectDatasetApi = new ObjectDatasetApiDefinition();

export default ObjectDatasetApi;
